import {
    GET_LIST_INTERACTION_TYPE,
    GET_SPECIFIC_INTERACTION_TYPE,
    UPDATE_SPECIFIC_INTERACTION_TYPE,
    CREATE_NEW_INTERACTION_TYPE,
    REMOVE_INTERACTION_TYPE,
    GET_INTERACTION_TYPE_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    interactionTypeList: [],
    currentInteractionType: null,
    interactionTypeActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_INTERACTION_TYPE: {
            return {
                ...state,
                interactionTypeList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_INTERACTION_TYPE_ACTIVE: {
            return {
                ...state,
                interactionTypeActiveList: action.payload?.data || [],
            }
        }
        case GET_SPECIFIC_INTERACTION_TYPE: {
            return { ...state, currentInteractionType: action.payload }
        }
        case CREATE_NEW_INTERACTION_TYPE: {
            return {
                ...state,
                interactionTypeList: [action.payload, ...state.interactionTypeList],
                interactionTypeActiveList: [action.payload, ...state.interactionTypeActiveList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_INTERACTION_TYPE: {
            let index = state.interactionTypeList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.interactionTypeList];
            temp[index] = action.payload;
            //
            let index2 = state.interactionTypeActiveList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.interactionTypeActiveList];
            temp[index2] = action.payload;

            return { ...state, interactionTypeList: temp, interactionTypeActiveList: temp2 }
        }
        case REMOVE_INTERACTION_TYPE: {
            let temp = state.interactionTypeList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.interactionTypeActiveList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, interactionTypeList: temp, interactionTypeActiveList: temp2 }
        }
        default: return { ...state };
    }
}
